import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  assignPayPalStoreAccount,
  AssignPayPalStoreAccountPayload,
} from 'api/admin/stores/assignPayPalStoreAccount';

export const useAssignPayPalStoreAccount = () => {
  return useMutation<unknown, AxiosError<{ error: string }>, AssignPayPalStoreAccountPayload>({
    mutationFn: async ({ storeId, paypalMerchantAccountId }) => {
      return assignPayPalStoreAccount({ storeId, paypalMerchantAccountId });
    },
    onSuccess: async () => {
      toaster('PayPal Account has been assigned', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(error?.response?.data?.error ?? 'An error occurred while assigning PayPal account', {
        icon: '❌',
      });
      return error;
    },
  });
};
